import { CsAgentRosterResponse, CsDashboardStatsResponse } from '~/components/CsDashboard/types';

import { request } from './common';

function basePath() {
  return window.configs.API_HOST + '/api/reporting';
}

export function getCsAgentRoster(options?: { signal?: AbortSignal }): Promise<CsAgentRosterResponse> {
  return request(`${basePath()}/cs-dashboard/roster`, {
    method: 'GET',
    ...options,
  });
}

export function getCsDashboardStats(
  params: { featureIds: string[]; startAt?: string; endAt?: string },
  options?: { signal?: AbortSignal },
): Promise<CsDashboardStatsResponse> {
  const searchParams = new URLSearchParams();
  params.featureIds.forEach((id) => searchParams.append('features', id));
  if (params.startAt) searchParams.set('start_at', params.startAt);
  if (params.endAt) searchParams.set('end_at', params.endAt);

  return request(`${basePath()}/cs-dashboard/stats?${searchParams.toString()}`, {
    method: 'GET',
    ...options,
  });
}
